/**
 * Maintenance configuration for Division 26 list page.
 */

/** Format ISO date string (YYYY-MM-DD) to MM/DD/YYYY */
export const formatDateUS = (dateStr) => {
  if (!dateStr) return '-';
  const [y, m, d] = dateStr.split('-');
  if (!y || !m || !d) return dateStr;
  return `${m}/${d}/${y}`;
};

const TARGET_TYPE_LABELS = { equipment: 'Equipment', device: 'Device', panel: 'Panel' };

export const maintenanceListConfig = {
  moduleName: 'Maintenance',
  testIdPrefix: 'elec-maint',
  apiBase: '/electrical-maintenance',
  columns: [
    { key: 'date', label: 'Date', cellClass: 'font-medium text-slate-900', render: (item) => formatDateUS(item.date) },
    { key: 'companyName', label: 'Company Name', cellClass: 'text-slate-700' },
    { key: 'technician', label: 'Technician', cellClass: 'text-slate-700' },
    { key: 'target', label: 'Maintenance For', cellClass: 'text-slate-700', render: (item) => {
      if (!item.targetType) return '-';
      const label = TARGET_TYPE_LABELS[item.targetType] || item.targetType;
      return item.targetName ? `${label}: ${item.targetName}` : label;
    }},
    { key: 'action', label: 'Action', cellClass: 'text-slate-700 max-w-[200px] truncate' },
    { key: 'photos', label: 'Photos', render: (item) => (item.photos?.length || 0) > 0 ? `${item.photos.length} photo${item.photos.length > 1 ? 's' : ''}` : '-' },
    { key: 'notes', label: 'Notes', cellClass: 'text-slate-500 max-w-[150px] truncate', render: (item) => item.notes?.trim() || '-' },
  ],
};

export const maintenanceFormFields = [
  { key: 'date', label: 'Date', type: 'date', required: true },
  { key: 'companyName', label: 'Company Name', type: 'text', required: true, placeholder: 'Enter company name' },
  { key: 'companyContact', label: 'Company Contact', type: 'phone', required: false, placeholder: '+1 555-0100' },
  { key: 'technician', label: 'Technician', type: 'technician', required: true, placeholder: 'Select or type technician name' },
  { key: 'action', label: 'Action', type: 'textarea', required: true, fullWidth: true, placeholder: 'Describe the maintenance performed' },
  { key: 'notes', label: 'Notes', type: 'textarea', required: false, fullWidth: true, placeholder: 'Additional notes...' },
];
